import React, { useState } from 'react';
import { Icon, Loader } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import AddRemarkModal from '../AddRemarkModal';
import Timestamp from '../Timestamp';

const Timeline = ({ data = [], title, hasMore, onLoadMore, loading = false, bankCases = [], opportunityID, token, fetchActivityLogs, loadMoreLabel, hideAddRemark = false }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showAddRemark, setShowAddRemark] = useState(false);
  const formatBold = (text) => {
    if (!text) return '';
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return (
      <span>
        {parts.map((part, index) => {
          const boldMatch = part.match(/^\*\*(.*?)\*\*$/);
          if (boldMatch) return <strong key={index}>{boldMatch[1]}</strong>;
          return <React.Fragment key={index}>{part}</React.Fragment>;
        })}
      </span>
    );
  };
  return (
    <div className="uc-timeline">
      <AddRemarkModal
        open={showAddRemark}
        bankCases={bankCases}
        opportunityID={opportunityID}
        token={token}
        onClose={() => setShowAddRemark(false)}
        onSuccess={fetchActivityLogs}
      />
      <div className="uc-timeline-title-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        {title || ''}
        {!hideAddRemark && (
          <Icon
            name="plus"
            className="minimal-plus-icon"
            role="button"
            tabIndex={0}
            aria-label="Add remark"
            onClick={() => setShowAddRemark(true)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                e.stopPropagation();
                setShowAddRemark(true);
              }
            }}
            style={{ cursor: 'pointer' }}
          />
        )}
      </div>

      {data.map((item, index) => (
        <div
          key={item.id}
          className="uc-timeline-item"
          onMouseEnter={() => setHoveredItem(index)}
          onMouseLeave={() => setHoveredItem(null)}
        >
          <div className="uc-timeline-icon">
            <Icon name={hoveredItem === index ? 'circle' : 'circle outline'} color="grey" size="small" />
          </div>
          {(index < data.length - 1 || hasMore) && <div className="uc-timeline-line" />}
          <div className="uc-timeline-content">
            <div className="uc-timeline-title">{formatBold(item.title)}</div>
            {item.description && (
              <div className="uc-timeline-description">{formatBold(item.description)}</div>
            )}
            <div className="uc-timeline-date">
              <Timestamp timestamp={item.date} format="DD/MM/YYYY hh:mm:ss A" />
              {item.userName && ` • ${item.userName}`}
            </div>
          </div>
        </div>
      ))}
      {hasMore && (
        <div className="uc-timeline-item">
          <div className="uc-timeline-icon">
            <Icon name="circle" color="grey" size="small" />
          </div>
          <div className="uc-timeline-content">
            {loading ? (
              <Loader active inline size="small" />
            ) : (
              <div
                role="button"
                tabIndex={0}
                aria-label="Load more"
                onClick={onLoadMore}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    e.stopPropagation();
                    onLoadMore();
                  }
                }}
                style={{ cursor: 'pointer', textAlign: 'center' }}
              >
                <span style={{ verticalAlign: 'middle' }}>{loadMoreLabel || 'Load More'}</span> <Icon name="chevron down" color="grey" size="small" style={{ marginLeft: '5px', verticalAlign: 'middle' }} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

Timeline.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
      description: PropTypes.string,
      date: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
      userName: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
  loading: PropTypes.bool,
  token: PropTypes.string,
  opportunityID: PropTypes.string,
  bankCases: PropTypes.arrayOf(
    PropTypes.object,
  ),
  fetchActivityLogs: PropTypes.func,
  loadMoreLabel: PropTypes.string,
  hideAddRemark: PropTypes.bool,
};

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCTimeline.jsx